export const defaultLocale = "hu";

export const localeOptions = [
  { id: "en", name: "English", direction: "ltr" },
  { id: "hu", name: "Magyar", direction: "ltr" },
];

export const fallbackLocale = ["hu", "en"];
